export const normalizeBearerToken = (rawToken = "") => {
  if (typeof rawToken !== "string") return "";

  const trimmed = rawToken.trim();
  if (!trimmed) return "";

  return trimmed.startsWith("Bearer ")
    ? trimmed.slice(7).trim()
    : trimmed;
};

export const isTokenExpired = (token = "") => {
  if (!token || typeof token !== "string") return true;

  try {
    const parts = token.split(".");
    if (parts.length < 2) return true;

    const payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = payload.padEnd(Math.ceil(payload.length / 4) * 4, "=");
    const decoded = JSON.parse(atob(padded));

    if (decoded.exp === undefined || decoded.exp === null) {
      return false;
    }

    const expiryMs = Number(decoded.exp) * 1000;
    return Number.isFinite(expiryMs) && expiryMs <= Date.now();
  } catch (error) {
    return true;
  }
};
